<script>
    export let value = null
    export let label = null
    export let required = false
    export let disabled = false
    export let validation = null
    export let errorMsg = null
    export let name = null
    export let style = ''
    export let valid = null
    export let placeholder = ''
    export let options = []
    export let info = null
    export let overline = true
    export let currentIndex = null
    import { Typography } from '.'
    // @ts-ignore
    import {
        clickOutside,
        searchFilterSimilarity,
        stringSimilarity,
    } from '$lib/utils'
    import ScrollBox from './ScrollBox.svelte'
    import { getContext, onMount, onDestroy } from 'svelte'
    import slide from '../../custom/animations/slide'
    import { ChevronDown, InfoOutline } from '../Icons'
    import { createEventDispatcher } from 'svelte'
    let toggle = false
    let display = null
    let viewport = null
    let focus
    let vp = { height: 0, width: 0 }
    let filtered = options
    let currentSearch = ''

    if (options instanceof Promise) {
        options.then((r) => {
            options = r
            filtered = options
        })
    }

    const dispatch = createEventDispatcher()
    function refreshSearch(e = null) {
        let tmpval = e ? e.target.value : e
        if (e && tmpval !== null && tmpval !== '') {
            let search = options.filter((o) =>
                `${o.label} ${o.value}`.match(
                    new RegExp(tmpval + '|' + tmpval.split(' ').join('|'), 'i')
                )
            )

            search.sort((a, b) => {
                return stringSimilarity(tmpval, a.label) >
                    stringSimilarity(tmpval, b.label)
                    ? -1
                    : 1
            })
            filtered = search
            // filtered = options.filter(o => searchFilterSimilarity(`${o.label} ${o.value}`, tmpval, 0.61))
        } else {
            filtered = options
        }
    }
    // @ts-ignore
    function onchange() {
        dispatch('change', {})
    }
    // @ts-ignore
    function onkeypress(e) {
        // refreshSearch(e.target.value);
        dispatch('keypress', {})
    }
    // @ts-ignore
    function onkeyup() {
        dispatch('keyup', {})
    }
    // @ts-ignore
    function ontype() {
        dispatch('type', {})
    }
    // @ts-ignore
    function onblur() {
        dispatch('blur', {})
    }
    function formatOptions() {
        let type = options.length > 0 ? typeof options[0] : null
        let tmp = type ? options.filter((x) => typeof x === type) : []
        if (type) {
            if (type === 'string') {
                options = tmp.map((x) => {
                    return { label: x, value: x }
                })
            } else if (type === 'object' && tmp[0] instanceof Array) {
                options = tmp.map((x) => {
                    return { label: x[1], value: x[0] }
                })
            } else {
                options = tmp
            }
        }
    }
    function keypress(event) {
        if (['Enter', 'Space'].indexOf(event.code) !== -1 && !toggle) {
            toggle = true
        } else if (event.code === 'Escape') {
            toggle = false
        } else if (event.code === 'ArrowDown') {
            event.preventDefault()
            if (currentIndex + 1 < options.length && !disabled) {
                currentIndex++
            }
        } else if (event.code === 'ArrowUp' && !disabled) {
            event.preventDefault()
            if (currentIndex - 1 >= 0) {
                currentIndex--
            }
        }
    }
    function indexChangeBuilder(ind) {
        return (_) => {
            currentSearch = filtered[ind].label
            currentIndex =
                options.findIndex((x) => x.label === currentSearch) || 0
        }
    }
    let formData = getContext('formData')
    onMount((_) => {
        formatOptions()
        refreshSearch()
        if (value !== null) {
            let ind = options.findIndex((x) => x.value === value)
            if (ind !== -1) currentIndex = ind
        }
        if (
            currentIndex !== null &&
            currentIndex >= 0 &&
            currentIndex < options.length
        ) {
            display = options[currentIndex].label
            value = options[currentIndex].value
        }
    })
    // @ts-ignore
    $: if (value) {
        // @ts-ignore
        valid = value && validation ? validation(value) : null
    }
    // @ts-ignore
    $: if (!disabled) toggle = false
    // @ts-ignore
    $: if (options) formatOptions()
    // @ts-ignore
    $: if (!!currentIndex || currentIndex === 0) {
        value = options[currentIndex].value
        display = options[currentIndex].label
    }
    // @ts-ignore
    $: if (((value && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid: !!valid,
                            validation: !!validation,
                            required,
                            value,
                            label,
                            labelOption: display,
                        },
                    ],
                ])
            )
        })
    // $: if(currentSearch !== '') ;
    // $: console.log(filtered);
    onDestroy((_) => {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
    // @ts-ignore
    $: if (options) filtered = options
    if (value) {
        currentSearch = options.find((x) => x.value === value)?.label || ''
    }
    // @ts-ignore
    $: if ([null, undefined, ''].includes(value)) {
        currentSearch = ''
    }
    $: if (value) {
        onchange()
    }
</script>

<div
    {style}
    class="box"
    class:disabled
    on:mouseover={(_) => (focus = true)}
    on:mouseout={(_) => (focus = false)}
    on:focus={(_) => (focus = true)}
    on:blur={(_) => (focus = false)}
>
    {#if label}
        <div
            style="position: relative; display: flex; gap: 7px; align-items: center; margin-bottom: 16px"
        >
            <Typography
                style="margin: 0 0 0 0;"
                type="caption"
                color={disabled ? 'grey-300' : 'black'}>{label}</Typography
            >
            {#if required && !disabled && !value}
                <InfoOutline
                    size={16}
                    style="cursor: pointer"
                    title="Campo requerido."
                />
            {/if}
        </div>
    {/if}
    <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
    <div
        tabindex="0"
        on:click={(_) => {
            if (!disabled) toggle = !toggle
        }}
        use:clickOutside
        on:clickout={(_) => (toggle = false)}
        on:keypress={keypress}
        on:keydown={keypress}
        on:focus={(_) => (focus = true)}
        on:blur={(_) => (focus = false)}
        style="position: relative; display: flex; cursor: pointer; gap: 12px; justify-content: space-between; align-items: center; width: 100%"
    >
        <input
            type="text"
            {disabled}
            {placeholder}
            bind:value={currentSearch}
            on:keydown={(_) => (toggle = true)}
            on:keyup={refreshSearch}
        />
        <ChevronDown color={disabled ? '#CCCCCC' : '#6F7072'} />
        {#if !disabled && toggle}
            <div
                on:blur={(_) => {
                    toggle = false
                }}
                transition:slide
                class="optionBox"
                bind:this={viewport}
                bind:clientWidth={vp.width}
                bind:clientHeight={vp.height}
            >
                <ScrollBox
                    width="100%"
                    height={filtered?.length >= 5
                        ? '235px'
                        : `${filtered.length * 47}px`}
                >
                    <ul>
                        {#each filtered as { value: val, label: txt }, i (i)}
                            <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
                            <li
                                tabindex="0"
                                class={currentIndex === parseInt(`${i}`)
                                    ? 'active'
                                    : ''}
                                on:keypress={(e) => {
                                    if (e.code === 'Enter') {
                                        indexChangeBuilder(i)()
                                        toggle = false
                                    }
                                }}
                                on:click={(_) => {
                                    indexChangeBuilder(i)()
                                }}
                            >
                                <Typography
                                    type="body"
                                    style="margin: 0; padding: 0"
                                    color="grey-800">{txt}</Typography
                                >
                            </li>
                        {/each}
                    </ul>
                </ScrollBox>
            </div>
        {/if}
    </div>
    <span
        class={!valid && validation && value && !disabled ? 'error' : ''}
        style={`${(!valid && errorMsg && !disabled) || info ? 'padding: 11px 0;' : ''}; ${overline ? `border-top: 1px var(--color-grey-${focus && !disabled ? '800' : '300'}) solid` : ''}`}
    >
        {#if value && validation && !valid && errorMsg && !disabled}
            <Typography type="label" style="margin: 0">{errorMsg}</Typography>
        {:else if info && !disabled}
            <Typography type="caption" color="grey-300" style="margin: 0"
                >{info}</Typography
            >
        {/if}
    </span>
</div>

<style>
    .box {
        width: 100%;
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        user-select: none;
    }
    input[type='text'] {
        background: transparent;
        padding: 0 0 11px 0;
        border-style: none;
        margin: 0;
        font-size: 17px;
        width: 90%;
        line-height: 22px;
        color: var(--color-black);
        outline: none;
        cursor: pointer;
        caret-color: #5496e3;
    }
    input[type='text']::placeholder {
        color: var(--color-grey-300);
    }
    span {
        width: 100%;
        display: flex;
        transition: all 0.2s ease-in-out;
    }

    .error {
        border-top: 1px var(--color-accent-alert-error) solid;
        color: var(--color-accent-alert-error);
        background: var(--color-accent-alert-error-bg);
    }

    .disabled {
        cursor: no-drop;
    }

    .disabled span {
        border-top: 1px var(--color-grey-300) solid;
        cursor: no-drop;
    }

    .disabled input[type='text']:disabled {
        color: var(--color-grey-400);
    }

    .optionBox {
        width: 100%;
        position: absolute;
        min-height: 22px;
        max-height: calc(5 * 47px);
        top: calc(100% + 1px);
        background: #ffffff;
        box-shadow:
            0px 2px 4px rgba(0, 0, 0, 0.2),
            0px -1px 1px rgba(0, 0, 0, 0.02);
        z-index: 9;
        overflow-y: scroll;
    }
    .optionBox::-webkit-scrollbar {
        display: none;
    }
    .optionBox ul {
        width: 100%;
        margin: 0;
        padding: 0;
        height: auto;
        display: flex;
        flex-direction: column;
        list-style: none;
    }
    .optionBox li {
        width: 100%;
        height: 47px;
        display: flex;
        align-items: center;
        padding-left: 19px;
        list-style: none;
        background: var(--color-white);
        transition: all 0.2s ease-in-out;
    }

    .optionBox li.active,
    .optionBox li:hover {
        background: var(--color-grey-050);
    }
</style>
